import { PATHS } from "@/lib/router";
import {
  CarbonSurveysPage,
  CarbonSurveysFormPage,
  CarbonTargetSettingsPage,
  CarbonInventoryDashboardPage,
  CarbonTargetSettingsFormPage,
  BankCarbonSubmissionsPage,
  BankCarbonSubmissionsFormPage,
} from "./pages";

export const carbonInventoryRoutes = [
  {
    path: PATHS.CARBON_DASHBOARD,
    element: <CarbonInventoryDashboardPage />,
    handle: { permission: { resource: "carbon_dashboard", action: "view" } },
  },
  {
    path: PATHS.CARBON_TARGETS,
    element: <CarbonTargetSettingsPage />,
    handle: {
      permission: { resource: "carbon_target_setting", action: "view" },
    },
  },
  {
    path: PATHS.CARBON_SUBMISSIONS,
    element: <BankCarbonSubmissionsPage />,
    handle: { permission: { resource: "carbon_submissions", action: "view" } },
  },
  {
    path: PATHS.CARBON_SUBMISSIONS_EDIT,
    element: <BankCarbonSubmissionsFormPage />,
    handle: {
      permission: { resource: "carbon_submissions", action: "update" },
    },
  },
  {
    path: PATHS.CARBON_TARGETS_NEW,
    element: <CarbonTargetSettingsFormPage />,
    handle: {
      permission: { resource: "carbon_target_setting", action: "create" },
    },
  },
  {
    path: PATHS.CARBON_TARGETS_EDIT,
    element: <CarbonTargetSettingsFormPage />,
    handle: {
      permission: { resource: "carbon_target_setting", action: "update" },
    },
  },
  {
    path: PATHS.CARBON_SURVEYS,
    element: <CarbonSurveysPage />,
    handle: { permission: { resource: "carbon_surveys", action: "view" } },
  },
  {
    path: PATHS.CARBON_SURVEYS_CREATE,
    element: <CarbonSurveysFormPage />,
    handle: { permission: { resource: "carbon_surveys", action: "create" } },
  },
  {
    path: PATHS.CARBON_SURVEYS_EDIT,
    element: <CarbonSurveysFormPage />,
    handle: { permission: { resource: "carbon_surveys", action: "update" } },
  },
];
